import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import {
  convertQueryStringToMap,
  removeQueryString,
  replaceWithPlaceholders,
  TelemetryType,
  telemetryTypesToModify
} from './helpers/applicationInsightsHelpers';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: import.meta.env.VITE_APP_APPINSIGHTS_KEY,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    correlationHeaderExcludedDomains: [
      '*.live-video.net',
      '*.my.salesforce-scrt.com',
      '*.cybersource.com',
      '*.trustarc.com',
      '*blog.pli.edu',
      '*connect.pli.edu'
    ]
  }
});

appInsights.loadAppInsights();

appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
  if (
    telemetryTypesToModify.includes((envelope.baseType ?? '') as TelemetryType) &&
    !!envelope.baseData
  ) {
    if (envelope.baseData?.name) {
      envelope.baseData.name = replaceWithPlaceholders(removeQueryString(envelope.baseData.name));
    }

    envelope.baseData.properties = {
      ...envelope.baseData.properties,
      ...convertQueryStringToMap(envelope.baseData?.target ?? '')
    };
  }
});

export { reactPlugin, appInsights };
